import React from 'react';
import css from './css.less';
const Err = (props) => {
  const { children, className, ...rest } = props;
  return (
    <div className={`${css.valueErr} ${className || ''}`} {...rest}>
      {children}
    </div>
  );
};
export default Err;
